import React from "react";

const TournamentCardSkeleton = () => {
  return (
    <div
      className="grid grid-cols-1 md:grid-cols-12 gap-2 md:gap-4 py-5 border-b border-brand-charcoal/15"
      role="article"
      aria-label="Loading tournament"
    >
      <div className="md:col-span-2 h-3 w-24 bg-brand-charcoal/10" />
      <div className="md:col-span-4 h-5 w-2/3 bg-brand-charcoal/10" />
      <div className="md:col-span-4 space-y-1">
        <div className="h-4 w-1/2 bg-brand-charcoal/10" />
        <div className="h-3 w-1/3 bg-brand-charcoal/10" />
      </div>
      <div className="md:col-span-2 h-4 w-20 bg-brand-charcoal/10 md:ml-auto" />
    </div>
  );
};

export default TournamentCardSkeleton;
